import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useAppContext } from "../../AppContext";
import axios from "axios";
import leftchevron from "../../Images/leftchevron.png";
import GiftImage from "../../Images/GiftImage.png";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { MyDomain } from "../../App";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";

const steps = ["In warehouse", "In the delivery section", "Done"];

export default function AdminOrdersGet() {
  const [TheOrder, setTheOrder] = useState({});
  const gridRef = useRef();

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { User, Token } = useAppContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [OneOrderData, setOneOrderData] = useState("");
  const [OrdersWithAllData, setOrdersWithAllData] = useState([]);
  const [loading2, setLoading2] = useState(true);
  const [error2, setError2] = useState(null);

  const GetAllOrdersWithAllData = async () => {
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(
        `${MyDomain}Orders/GetAllOrdersWithAllData`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      console.log(response.data);
      setOrdersWithAllData(response.data);
      setLoading2(false);
    } catch (err) {
      console.log(err);
      setError2(err.response.data.error);
      setLoading2(false);
    }
  };

  useEffect(() => {
    GetAllOrdersWithAllData();
  }, []);

  const handleUpdateOrderStatus = async (OrderId, OrderStatus, TheOBJ) => {
    const data = {
      Id: OrderId,
      OrderStatus: OrderStatus,
    };
    console.log(data);
    try {
      const response = await axios.put(
        `${MyDomain}Orders/UpdateOrderStatus`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);

      setOneOrderData((prevData) => ({
        ...prevData,
        order: {
          ...prevData.order,
          orderStatus: OrderStatus,
        },
      }));

      setOrdersWithAllData((prevOrders) =>
        prevOrders.map((obj) =>
          obj.order.id === OrderId
            ? {
                ...obj,
                order: {
                  ...obj.order,
                  orderStatus: OrderStatus,
                },
              }
            : obj
        )
      );
    } catch (error) {
      console.log("Login error:", error.response?.data || error.message);
    }
  };

  const OrderStatusFunc = (params) => {
    const statusConfig = {
      1: { bg: "#dcfce7", color: "#166534", text: "New order" },
      2: { bg: "#fef9c3", color: "#854d0e", text: "With Delivery" },
      3: { bg: "#fee2e2", color: "#991b1b", text: "Done" },
    };
    const config = statusConfig[params.value] || statusConfig[3];
    return (
      <span
        style={{
          backgroundColor: config.bg,
          color: config.color,
          borderRadius: 6,
          padding: "6px 12px",
          fontWeight: 600,
          fontSize: 13,
          display: "inline-block",
        }}
      >
        {config.text}
      </span>
    );
  };

  const PaymentTypeFunc = (params) => {
    const paymentConfig = {
      1: { bg: "#dcfce7", color: "#166534", text: "Cash" },
      2: { bg: "#f3e8ff", color: "#6b21a8", text: "Credit card" },
    };
    const config = paymentConfig[params.value] || {
      bg: "#fee2e2",
      color: "#991b1b",
      text: "Unknown",
    };
    return (
      <span
        style={{
          backgroundColor: config.bg,
          color: config.color,
          borderRadius: 6,
          padding: "6px 12px",
          fontWeight: 600,
          fontSize: 13,
          display: "inline-block",
        }}
      >
        {config.text}
      </span>
    );
  };

  const DateTimeCellRenderer = (props) => {
    return (
      <div
        style={{
          lineHeight: "1.5",
          padding: 5,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div style={{ fontWeight: 500 }}>{props.data.order.dateOrder}</div>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          {props.data.order.timeOrder}
        </div>
      </div>
    );
  };

  const FirstAndLastNameCellRenderer = (props) => {
    return (
      <div
        style={{
          lineHeight: "1.5",
          padding: 5,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div style={{ fontWeight: 500 }}>
          {props.data.addresses.firstName} {props.data.addresses.lastName}
        </div>
      </div>
    );
  };

  const BtnCellRenderer = (rowData) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <button
          style={{
            backgroundColor: "#3b82f6",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 600,
            padding: "8px 16px",
            borderRadius: 6,
            transition: "all 0.2s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#2563eb")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#3b82f6")}
          onClick={() => {
            setOneOrderData(rowData.data);
            setTheOrder(rowData.data);
            console.log(rowData.data);
          }}
        >
          View Details
        </button>
      </div>
    );
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      minWidth: MyWidth >= 1024 ? 100 : 75,
      width: MyWidth >= 1024 ? 100 : 75,
      flex: MyWidth > 766 ? 1 : null,
      headerName: "Order ID",
      field: "order.id",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) => `#${params.value}`,
      cellStyle: { fontWeight: 600 },
    },
    {
      flex: MyWidth > 766 ? 1 : null,
      headerName: "Customer",
      headerClass: "my-header-class",
      minWidth: MyWidth >= 1024 ? 120 : 120,
      width: 120,
      filter: true,
      cellRenderer: FirstAndLastNameCellRenderer,
      valueGetter: (params) =>
        `${params.data.addresses.firstName} ${params.data.addresses.lastName}`,
    },
    {
      minWidth: MyWidth >= 1024 ? 150 : 130,
      width: MyWidth >= 1024 ? 150 : 130,
      flex: MyWidth > 766 ? 1 : null,
      headerName: "Status",
      field: "order.orderStatus",
      filter: "agTextColumnFilter",
      headerClass: "my-header-class",
      cellRenderer: OrderStatusFunc,
    },
    {
      minWidth: MyWidth >= 1024 ? 150 : 130,
      width: MyWidth >= 1024 ? 150 : 130,
      flex: MyWidth > 766 ? 1 : null,
      headerName: "Payment",
      field: "order.paymentType",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      cellRenderer: PaymentTypeFunc,
    },
    {
      minWidth: MyWidth >= 1024 ? 120 : 100,
      width: MyWidth >= 1024 ? 120 : 100,
      headerName: "Total",
      flex: MyWidth > 766 ? 1 : null,
      field: "order.price",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) => `₪${params.value}`,
      cellStyle: { fontWeight: 600, color: "#059669" },
    },
    {
      minWidth: MyWidth >= 1024 ? 120 : 120,
      width: 120,
      flex: MyWidth > 766 ? 1 : null,
      headerName: "Date & Time",
      headerClass: "my-header-class",
      filter: true,
      cellRenderer: DateTimeCellRenderer,
      valueGetter: (params) =>
        `${params.data.order.dateOrder} ${params.data.order.timeOrder}`,
    },
    {
      minWidth: MyWidth >= 1024 ? 150 : 130,
      width: MyWidth >= 1024 ? 150 : 130,
      headerName: "City",
      flex: MyWidth > 766 ? 1 : null,
      field: "addresses.city",
      filter: "agTextColumnFilter",
      headerClass: "my-header-class",
      valueFormatter: (params) => `${params.value}`,
    },
    {
      minWidth: MyWidth >= 1024 ? 100 : 50,
      width: 100,
      flex: MyWidth > 766 ? 1 : null,
      headerName: "Actions",
      headerClass: "my-header-class",
      field: "Action",
      cellRenderer: BtnCellRenderer,
    },
  ]);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 50 : 60);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9fafb" };
      }
    },
  };

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: true,
    }),
    []
  );

  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const totalPrice = TheOrder.products?.reduce(
    (sum, item) => sum + item.priceBeforeDiscount,
    0
  );

  const totalPrice2 = TheOrder.products?.reduce(
    (sum, item) => sum + item.priceAfterDiscount,
    0
  );

  const [ChooseDirection, setChooseDirection] = useState("All Districts");

  const Direction = [
    "All Districts",
    "Northern District",
    "Southern District",
    "Jerusalem District",
    "Southern Triangle",
    "Northern Triangle",
    "Haifa and Carmel region",
  ];

  const filteredItems =
    ChooseDirection === "All Districts"
      ? OrdersWithAllData
      : OrdersWithAllData.filter(
          (item) => item.addresses.direction === ChooseDirection
        );

  return (
    <div
      style={{
        backgroundColor: "#f9fafb",
        minHeight: "100vh",
        padding: "24px",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: 32 }}>
        <h1
          style={{
            fontSize: 28,
            fontWeight: 700,
            color: "#111827",
            marginBottom: 8,
          }}
        >
          Orders Management
        </h1>
        <p style={{ color: "#6b7280", fontSize: 14 }}>
          Manage and track all customer orders
        </p>
      </div>

      {/* District Filter */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 12,
          padding: 24,
          marginBottom: 24,
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
        }}
      >
        <h3
          style={{
            fontSize: 16,
            fontWeight: 600,
            color: "#111827",
            marginBottom: 16,
          }}
        >
          Filter by District
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: 12,
          }}
        >
          {Direction.map((Cat) => (
            <button
              key={Cat}
              style={{
                backgroundColor: ChooseDirection === Cat ? "#3b82f6" : "white",
                color: ChooseDirection === Cat ? "white" : "#374151",
                padding: "12px 16px",
                border: ChooseDirection === Cat ? "none" : "1px solid #e5e7eb",
                borderRadius: 8,
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 500,
                transition: "all 0.2s",
              }}
              onMouseOver={(e) => {
                if (ChooseDirection !== Cat) {
                  e.target.style.backgroundColor = "#f3f4f6";
                }
              }}
              onMouseOut={(e) => {
                if (ChooseDirection !== Cat) {
                  e.target.style.backgroundColor = "white";
                }
              }}
              onClick={() => {
                setChooseDirection(Cat);
              }}
            >
              {Cat}
            </button>
          ))}
        </div>
      </div>

      {/* Orders Table */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 12,
          padding: 24,
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
          marginBottom: 24,
        }}
      >
        <h3
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#111827",
            marginBottom: 16,
          }}
        >
          All Orders ({filteredItems.length})
        </h3>
        <div style={containerStyle}>
          <div style={gridStyle} className="ag-theme-alpine">
            <AgGridReact
              ref={gridRef}
              rowData={filteredItems}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              animateRows={true}
              rowSelection="multiple"
              onCellClicked={cellClickedListener}
              onGridReady={onGridReady}
              gridOptions={gridOptions}
              suppressScrollOnNewData={true}
              getRowHeight={getRowHeight}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={10}
            />
          </div>
        </div>
      </div>

      {/* Order Details */}
      {OneOrderData !== "" && (
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 12,
            padding: 24,
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 24,
              paddingBottom: 16,
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <h2
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#111827",
              }}
            >
              Order Details - #{OneOrderData.order?.id}
            </h2>
            <div>
              {OneOrderData.order?.paymentType === 1 ? (
                <span
                  style={{
                    backgroundColor: "#dcfce7",
                    color: "#166534",
                    borderRadius: 6,
                    padding: "8px 16px",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Cash Payment
                </span>
              ) : OneOrderData.order?.paymentType === 2 ? (
                <span
                  style={{
                    backgroundColor: "#f3e8ff",
                    color: "#6b21a8",
                    borderRadius: 6,
                    padding: "8px 16px",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Credit Card
                </span>
              ) : (
                <span
                  style={{
                    backgroundColor: "#fee2e2",
                    color: "#991b1b",
                    borderRadius: 6,
                    padding: "8px 16px",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  Unknown
                </span>
              )}
            </div>
          </div>

          {/* Order Progress Stepper - Mobile */}
          {MyWidth <= 1024 && (
            <div style={{ marginBottom: 32 }}>
              <Box sx={{ width: "100%" }}>
                <Stepper
                  activeStep={OneOrderData.order?.orderStatus - 1}
                  alternativeLabel
                >
                  {steps.map((label, index) => (
                    <Step
                      key={label}
                      onClick={async () => {
                        await handleUpdateOrderStatus(
                          OneOrderData.order?.id,
                          index + 1,
                          OneOrderData
                        );
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>
            </div>
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: MyWidth <= 1024 ? "1fr" : "60% 40%",
              gap: 24,
            }}
          >
            {/* Left Column - Order Info */}
            <div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    MyWidth <= 1024 ? "1fr" : "repeat(2, 1fr)",
                  gap: 24,
                  marginBottom: 24,
                }}
              >
                {/* Order Details Card */}
                <div
                  style={{
                    backgroundColor: "#f9fafb",
                    borderRadius: 8,
                    padding: 20,
                  }}
                >
                  <h3
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      color: "#111827",
                      marginBottom: 16,
                    }}
                  >
                    Order Information
                  </h3>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#6b7280", fontSize: 14 }}>
                        Order ID
                      </span>
                      <span
                        style={{
                          backgroundColor: "#e5e7eb",
                          padding: "2px 8px",
                          borderRadius: 4,
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        #{OneOrderData.order?.id}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#6b7280", fontSize: 14 }}>
                        Total Price
                      </span>
                      <span style={{ fontWeight: 600, color: "#059669" }}>
                        ₪{OneOrderData.order?.price}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#6b7280", fontSize: 14 }}>
                        Date
                      </span>
                      <span style={{ fontSize: 14 }}>
                        {OneOrderData.order?.dateOrder}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#6b7280", fontSize: 14 }}>
                        Time
                      </span>
                      <span style={{ fontSize: 14 }}>
                        {OneOrderData.order?.timeOrder}
                      </span>
                    </div>
                    {OneOrderData.order?.comment && (
                      <div style={{ marginTop: 8 }}>
                        <span
                          style={{
                            color: "#6b7280",
                            fontSize: 14,
                            display: "block",
                            marginBottom: 4,
                          }}
                        >
                          Comment
                        </span>
                        <p
                          style={{
                            fontSize: 14,
                            backgroundColor: "white",
                            padding: 8,
                            borderRadius: 4,
                            margin: 0,
                          }}
                        >
                          {OneOrderData.order?.comment}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Address Details Card */}
                <div
                  style={{
                    backgroundColor: "#f9fafb",
                    borderRadius: 8,
                    padding: 20,
                  }}
                >
                  <h3
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      color: "#111827",
                      marginBottom: 16,
                    }}
                  >
                    Delivery Address
                  </h3>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    <div>
                      <span style={{ color: "#6b7280", fontSize: 13 }}>
                        Full Name
                      </span>
                      <p style={{ margin: "4px 0 0 0", fontWeight: 500 }}>
                        {OneOrderData.addresses?.firstName}{" "}
                        {OneOrderData.addresses?.lastName}
                      </p>
                    </div>
                    <div>
                      <span style={{ color: "#6b7280", fontSize: 13 }}>
                        Phone Number
                      </span>
                      <p style={{ margin: "4px 0 0 0", fontWeight: 500 }}>
                        {OneOrderData.addresses?.phonenumber}
                      </p>
                    </div>
                    <div>
                      <span style={{ color: "#6b7280", fontSize: 13 }}>
                        Address
                      </span>
                      <p style={{ margin: "4px 0 0 0", fontWeight: 500 }}>
                        {OneOrderData.addresses?.street}{" "}
                        {OneOrderData.addresses?.building},{" "}
                        {OneOrderData.addresses?.city}
                      </p>
                      <p
                        style={{
                          margin: "4px 0 0 0",
                          color: "#6b7280",
                          fontSize: 13,
                        }}
                      >
                        Postal Code: {OneOrderData.addresses?.zipCode}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Promo Code */}
              {OneOrderData.promoCode !== null && (
                <div
                  style={{
                    backgroundColor: "#faf5ff",
                    border: "1px solid #e9d5ff",
                    borderRadius: 8,
                    padding: 16,
                    marginBottom: 24,
                  }}
                >
                  <h3
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#6b21a8",
                      marginBottom: 12,
                    }}
                  >
                    🎉 Promo Code Applied
                  </h3>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span style={{ fontSize: 14 }}>
                      Code: <strong>{OneOrderData.promoCode?.name}</strong>
                    </span>
                    <span
                      style={{
                        backgroundColor: "#7e22ce",
                        color: "white",
                        padding: "4px 12px",
                        borderRadius: 4,
                        fontSize: 13,
                        fontWeight: 600,
                      }}
                    >
                      {OneOrderData.promoCode?.discount}% OFF
                    </span>
                  </div>
                </div>
              )}

              {/* Order Progress Stepper - Desktop */}
              {MyWidth > 1024 && (
                <div style={{ marginTop: 24 }}>
                  <h3
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      color: "#111827",
                      marginBottom: 16,
                    }}
                  >
                    Order Status
                  </h3>
                  <Box sx={{ width: "100%" }}>
                    <Stepper
                      activeStep={OneOrderData.order?.orderStatus - 1}
                      alternativeLabel
                    >
                      {steps.map((label, index) => (
                        <Step
                          key={label}
                          onClick={async () => {
                            await handleUpdateOrderStatus(
                              OneOrderData.order?.id,
                              index + 1,
                              OneOrderData
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </div>
              )}
            </div>

            {/* Right Column - Products & Summary */}
            <div>
              {/* Products List */}
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  borderRadius: 8,
                  padding: 20,
                  marginBottom: 20,
                }}
              >
                <h3
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#111827",
                    marginBottom: 16,
                  }}
                >
                  Products ({OneOrderData.products?.length})
                </h3>
                <div
                  style={{
                    maxHeight: 400,
                    overflowY: "auto",
                    marginBottom: 16,
                  }}
                >
                  {OneOrderData.products?.map((product, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "white",
                        borderRadius: 6,
                        padding: 12,
                        marginBottom: 12,
                        display: "flex",
                        gap: 12,
                      }}
                    >
                      <img
                        src={product.image}
                        style={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 6,
                        }}
                        alt={product.name}
                      />
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            marginBottom: 4,
                          }}
                        >
                          <h4
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              margin: 0,
                              color: "#111827",
                            }}
                          >
                            {product.name}
                          </h4>
                          <span
                            style={{
                              fontSize: 12,
                              backgroundColor: "#e5e7eb",
                              padding: "2px 6px",
                              borderRadius: 3,
                            }}
                          >
                            #{product.idOfProduct}
                          </span>
                        </div>
                        <p
                          style={{
                            fontSize: 12,
                            color: "#6b7280",
                            margin: "4px 0",
                          }}
                        >
                          {product.productType}
                        </p>
                        {product.isGift === 2 ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              marginTop: 8,
                            }}
                          >
                            <img
                              src={GiftImage}
                              style={{ width: 18, height: 18 }}
                            />
                            <span
                              style={{
                                backgroundColor: "#7e22ce",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: 4,
                                fontSize: 12,
                                fontWeight: 600,
                              }}
                            >
                              FREE GIFT
                            </span>
                          </div>
                        ) : (
                          <div style={{ marginTop: 8 }}>
                            {product.discount !== 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    color: "#dc2626",
                                  }}
                                >
                                  ₪{product.priceAfterDiscount}
                                </span>
                                <span
                                  style={{
                                    fontSize: 13,
                                    textDecoration: "line-through",
                                    color: "#9ca3af",
                                  }}
                                >
                                  ₪{product.priceBeforeDiscount}
                                </span>
                                <span
                                  style={{
                                    backgroundColor: "#7e22ce",
                                    color: "white",
                                    padding: "2px 8px",
                                    borderRadius: 4,
                                    fontSize: 11,
                                    fontWeight: 600,
                                  }}
                                >
                                  {product.discount}%
                                </span>
                              </div>
                            ) : (
                              <span
                                style={{
                                  fontSize: 16,
                                  fontWeight: 700,
                                  color: "#059669",
                                }}
                              >
                                ₪{product.priceAfterDiscount}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Price Summary */}
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  borderRadius: 8,
                  padding: 20,
                }}
              >
                <h3
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#111827",
                    marginBottom: 16,
                  }}
                >
                  Order Summary
                </h3>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 12 }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 14,
                    }}
                  >
                    <span style={{ color: "#6b7280" }}>Subtotal</span>
                    <span style={{ fontWeight: 500 }}>₪{totalPrice}</span>
                  </div>
                  {OneOrderData.promoCode !== null && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: 14,
                        }}
                      >
                        <span style={{ color: "#6b7280" }}>
                          After Product Discounts
                        </span>
                        <span style={{ fontWeight: 500 }}>₪{totalPrice2}</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: 14,
                          color: "#7e22ce",
                        }}
                      >
                        <span>
                          Promo Code ({OneOrderData.promoCode?.discount}%)
                        </span>
                        <span style={{ fontWeight: 600 }}>
                          -₪
                          {(
                            (totalPrice2 * OneOrderData.promoCode?.discount) /
                            100
                          ).toFixed(2)}
                        </span>
                      </div>
                    </>
                  )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 14,
                    }}
                  >
                    <span style={{ color: "#6b7280" }}>Delivery Fee</span>
                    <span style={{ fontWeight: 500 }}>
                      {totalPrice <= 200 ? "₪20" : "₪0 (Free)"}
                    </span>
                  </div>
                  <div
                    style={{
                      height: 1,
                      backgroundColor: "#e5e7eb",
                      margin: "8px 0",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 18,
                      fontWeight: 700,
                    }}
                  >
                    <span style={{ color: "#111827" }}>Grand Total</span>
                    <span style={{ color: "#059669" }}>
                      ₪{OneOrderData.order?.price}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          .ag-theme-alpine {
            --ag-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
            --ag-border-color: #e5e7eb;
            --ag-header-background-color: #f9fafb;
            --ag-odd-row-background-color: #ffffff;
            --ag-row-hover-color: #f3f4f6;
          }
          
          .ag-theme-alpine .ag-root-wrapper {
            border: 1px solid #e5e7eb;
            border-radius: 8px;
          }
          
          .ag-theme-alpine .ag-header {
            font-weight: 600;
            color: #374151;
          }
          
          .my-header-class {
            background-color: #f9fafb;
            font-weight: 600;
          }
          
          .ag-theme-alpine .ag-row {
            border-bottom: 1px solid #f3f4f6;
          }
          
          /* Custom scrollbar */
          ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          
          ::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          
          ::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;
          }
          
          ::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
        `}
      </style>
    </div>
  );
}
